import QueryString from 'qs'
import { ACCESS_KEY, urlAPI, USER_ID_KEY } from '../../../../urls'
import { dataFetchingFinish, dataFetchingStart } from '../../../slices/modalSlice'

import { type AppDispatch, type RootState } from '../../../store'
import { type IOffer, offersSlice } from '../../../slices/offersSlice'
import { getErrorss } from '../../../../functions/errors/GetErrors'
import { setFilterNavigate } from '../../../slices/scheduleSlice'
import { getNameUser } from '../../../../functions/agent/agentModuleComponent/getNameUser'
import { getUnitAddress } from '../../../../functions/agent/agentModuleComponent/getUnitAddres'
import { type User } from '../../../slices/userSlice'
import { sendNotification } from '../../../../functions/shared/notifications/sendNotification'
import { toUTCWithOffset } from '../../../../functions/agent/date/toUTCWithOffset'
import { getBelongsUnitForOffer } from '../../../../functions/shared/schedule/getBelongsUnit'
import { getCurrentDubaiDate } from '../../../../functions/agent/date/getCurrentDubaiDate'
import { getQueryOffers } from '../../../../functions/shared/api/queries/getQueryOffers'

export const negotiateOfferAgentToAgent = (bodyClient:  Record<string, any>) => {
    const jwt = window.localStorage.getItem(ACCESS_KEY)
    const userID = window.localStorage.getItem(USER_ID_KEY) ?? '';
    const offerID = bodyClient.objectID

    return async (dispatch: AppDispatch, getState: () => RootState) => {
        try {
            dispatch(dataFetchingStart())
            const units: any = getState().units.units
            const currentUnit = units?.filter((el: any) => el.id === Number(bodyClient.unitID))?.[0]
            const currentUser = getState().user.currentUser

            const offer = getState().offers?.offers?.find((offer) => offer.id === Number(offerID))
            const isSale = currentUnit?.attributes.Marketing?.Use === 'For sale'
            const offerStatuses = offer?.attributes?.Statuses
            const ownerUnit = getBelongsUnitForOffer(offer as IOffer)

            const offerType = {
                ...offer?.attributes?.Type?.[0],
                Offer: bodyClient.Type?.[0]?.Offer,
                ...(isSale ? {} : {
                    ContractStartDate: bodyClient.Type.ContractStartDate,
                    Payments: bodyClient.Type.Payments, 
                    Duration: bodyClient.Type.Duration }),
                AdditionalNotes: bodyClient.Type.AdditionalNotes
            }

            const bodyObject = {
                method: 'PUT',
                collection: 'offers',
                id: Number(offerID),
                query : getQueryOffers(),

                body: {
                    Type: [offerType],
                    Statuses: ((offerStatuses?.includes('Negotiated by other agent')) === true) ? ['Negotiated by agent'] : ['Negotiated by other agent'] ,
                    Notify:  ((offerStatuses?.includes('Negotiated by other agent')) === true) ? 'Other Agent' : 'Agent'
                }
            }

            const response = await fetch(`${urlAPI}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'BSO-Hash': '02ns30nsBSO!',
                    Authorization: `Bearer ${jwt as string}`
                },
                body: JSON.stringify(bodyObject)
            })
            const dataJSON = await response.json()

            if (dataJSON.success) {
                if (dataJSON.response.error != null) {
                    dispatch(offersSlice.actions.offersFetchingError(getErrorss(dataJSON)))
                    dispatch(dataFetchingFinish())
                    return { ...dataJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
                } else {
                    const nameUser = getNameUser(currentUser as User)
                    const unitAdress = getUnitAddress(currentUnit)
                    if (Number(offer?.attributes?.AgentToAgentID) === currentUser.id) {
                        await sendNotification(toUTCWithOffset(getCurrentDubaiDate(), 1), Number(offer?.attributes?.User.data?.id), dataJSON?.response?.data?.id, 'user-offer-negotiate', `Attention kindly, ${nameUser} did offer on ${unitAdress} , please respond.`)
                    } else {
                        await sendNotification(toUTCWithOffset(getCurrentDubaiDate(), 1), Number(userID), dataJSON?.response?.data?.id, 'admin-offer-negotiate', `Attention kindly, ${nameUser} did offer on ${unitAdress} , please respond.`)
                    }

                    dispatch(setFilterNavigate('offers'))
                    dispatch(dataFetchingFinish())
                    return {
                        textNavigate: `/agent/modalView/offer_modal/${dataJSON?.response?.data?.attributes?.Unit?.data?.id}/${dataJSON?.response?.data?.id}/other_agent_s_unit?type=${dataJSON?.response?.data?.attributes?.Type?.[0]?.__component?.split('.')?.[1] ?? 'not'}` ,
                        isSuccessful: true,
                        textNotification: 'Wait change text',
                        title: 'Offer has been created'
                    }
                }
            } else {
                dispatch(offersSlice.actions.offersFetchingError(getErrorss(dataJSON)))
                dispatch(dataFetchingFinish())
                return { textNavigate: '', isSuccessful: false, textNotification: '' }
            }
        } catch (e) {
            dispatch(dataFetchingFinish())
            console.log(e)
        }
    }
}
